import { render, staticRenderFns } from "./DischargeDetails.vue?vue&type=template&id=3ef074bc&"
import script from "./DischargeDetails.vue?vue&type=script&lang=js&"
export * from "./DischargeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports